const DataProtection = () => {
  return (
    <article>
      <p>Aktualisiert: 22.04.2026</p>
      <p>
        <strong>1. Verantwortlicher</strong> Verantwortlich für die Verarbeitung
        personenbezogener Daten ist: <br />
        Jonathan Patzwaldt
        <br /> Moltkestrasse 23, 23564 Lübeck <br />
        E-Mail:{" "}
        <a href="mailto:kontakt@surfanzeigen.de" className="link">
          kontakt@surfanzeigen.de
        </a>
      </p>

      <ul>
        <p>
          <strong>Verwendete Begriffe</strong>
        </p>
        <li>
          Mit "Seite" ist die Webseite Surfanzeigen, die unter
          www.surfanzeigen.de erreichbar ist, gemeint. Mit "Konto" ist das
          Nutzerkonto gemeint, welches mit einem Passwort geschützt ist.
          "Besucher" sind natürliche Personen, die unsere Seite besuchen aber
          kein Konto angelegt haben. "Nutzer" sind natürliche Personen, die
          unsere Seite besuchen und ein Konto angelegt haben.
        </li>
      </ul>
      <br />
      <p>
        <strong>2. Welche Daten wir erheben</strong>
      </p>
      <ul>
        <li>
          Wenn die Seite besucht wird: Auf Grundlage Art. 6 Abs. 1 lit. f DSGVO
          (berechtigtes Interesse: technische Bereitstellung der Website) werden
          deine IP-Adresse, Browser-Informationen, Spracheinstellungen,
          Zugriffszeiten und technische Anfrageinformationen verarbeitet, um die
          Antwort in Form unserer Website bereitzustellen. Das Hosting erfolgt
          wie folgt: Die statischen Frontend-Dateien werden über Vercel Inc.,
          340 S Lemon Ave #4133, Walnut, CA 91789, USA bereitgestellt. Dabei
          können Daten wie IP-Adresse und technische Anfrageinformationen auf
          Servern außerhalb der EU, insbesondere in den USA, verarbeitet werden.
          Die USA bieten kein mit der EU vergleichbares Datenschutzniveau. Es
          besteht insbesondere die Möglichkeit, dass US-Behörden auf diese Daten
          zugreifen, ohne dass wirksame Rechtsmittel dagegen bestehen. Die
          Übermittlung erfolgt auf Grundlage von Standardvertragsklauseln gemäß
          Art. 46 Abs. 2 lit. c DSGVO. Eine Kopie dieser Garantien kann unter
          Vercels Datenschutzrichtlinie eingesehen oder per E-Mail bei uns
          angefordert werden:{" "}
          <a href="mailto:kontakt@surfanzeigen.de" className="link">
            kontakt@surfanzeigen.de
          </a>
          . Diese Daten dienen ausschließlich der technischen Bereitstellung der
          Website. Alle personenbezogenen Daten, die wir zu deinem Nutzerkonto
          verarbeiten, d.h. E-Mail-Adresse, Anzeigen, Nachrichten, Profildaten,
          werden ausschließlich auf Servern der Netcup GmbH innerhalb der
          Europäischen Union gespeichert und verarbeitet.
        </li>
        <br />
        <li>
          Wir wollen allen Nutzern ermöglichen, miteinander sicher zu
          interagieren. Auch der Nutzer hat ein Interesse keinen Spam auf der
          Plattform zu sehen, dass die Plattform schnell reagiert, und dass er
          echte Angebote sieht. Um den Zugriff auf kritische Funktionen vor
          schädlichen Akteuren wie Bots, Spam, oder allgemeinem Missbrauch zu
          schützen wird daher ein Nutzerkonto benötigt. Um dies sicherzustellen
          musst du dich registrieren. Bei der Registrierung speichern wir die
          E-Mail-Adresse zur Kontoverwaltung und Kommunikation (Art. 6 Abs. 1
          lit. b DSGVO). Das Passwort wird bei der Übertragung durch
          HTTPS/TLS-Verschlüsselung geschützt und ausschließlich als
          kryptografischer Hash gespeichert. Der Klartext des Passworts ist für
          uns zu keinem Zeitpunkt dauerhaft einsehbar. Wir speichern deine
          Zustimmung zur Datenschutzerklärung und den Nutzungsbedingungen, um
          unserer Nachweispflicht gemäß Art. 7 Abs. 1 DSGVO nachzukommen (Art. 6
          Abs. 1 lit. c DSGVO). Folgende Angaben sind optional und dienen der
          Personalisierung deines Kontos (Art. 6 Abs. 1 lit. b DSGVO): Die
          Angabe eines Nutzernamen, ein Profilbild und eine Beschreibung. Bei
          Registrierung wird ein zufälliger Nutzername gewählt. Das Ändern des
          Nutzernamen ist optional, das Hochladen eines Profilbildes und
          Beschreibung sind auch freiwillig. Der Nutzername kann jederzeit
          geändert werden, das Profilbild und die Beschreibung jederzeit
          gelöscht oder geändert werden. Diese Informationen werden auf deinem
          Profil öffentlich zugänglich angezeigt. Bitte lade daher keine Bilder
          hoch, auf denen Personen erkennbar sind, ohne deren Einwilligung.
          Nutzerkonten werden nach 12 Monaten Inaktivität gelöscht. Zur
          Feststellung der Inaktivität wird gespeichert, wann die letzte
          authentifizierte Anfrage des Nutzers den Server erreicht hat (Art. 6
          Abs. 1 lit. f DSGVO (berechtigtes Interesse)).
        </li>
        <br />
        <li>
          Das Aufgeben von Anzeigen ist nur mit einem Konto möglich, da wir Spam
          und Betrug möglichst verhindern möchten. Wenn du eine Anzeige
          erstellst, werden die Daten erhoben, die du in das Formular eingibst,
          sowie ein Zeitstempel und die eindeutige Identifikationsnummer des
          Nutzers, der die Anzeige veröffentlicht. Du kannst die Anzeige auf
          "Nicht gelistet" stellen; das beschränkt jedoch nicht vollständig den
          Zugriff anderer Besucher auf die Daten der Anzeige, sondern die
          Anzeige wird nicht öffentlich in den Suchergebnissen erscheinenn. So
          kannst du die Anzeige in Ruhe mit Freunden teilen, ohne dass Dritten
          diese Anzeige direkt angezeigt wird. Wenn du verhindern möchtest, dass
          andere Nutzer auf die Anzeige zugreifen, lösche die Anzeige. Die
          Verarbeitung dieser Daten erfolgt zur Bereitstellung der
          Plattformfunktionen (Anzeigen anbieten) und zur Vertragserfüllung
          gemäß Art. 6 Abs. 1 lit. b DSGVO.
        </li>
        <br />
        <li>
          Wenn du mit anderen Nutzern Nachrichten austauschst, werden diese
          Inhalte während der Übertragung zwischen deinem Gerät und unserem
          Server verschlüsselt (Transportverschlüsselung via TLS). Auf dem
          Server werden die Nachrichten verschlüsselt in der Datenbank
          gespeichert (symmetrische Verschlüsselung mit einem Datenbank-Secret).
          Die Nachrichtenfunktion dient dazu, den Austausch zwischen Käufern und
          Verkäufern zu ermöglichen und ist wesentlicher Bestandteil unserer
          Plattform. Die Verarbeitung erfolgt zur Vertragserfüllung gemäß Art. 6
          Abs. 1 lit. b DSGVO. Wichtig: Dies ist keine
          Ende-zu-Ende-Verschlüsselung. Das bedeutet, dass wir als Betreiber
          technisch in der Lage sind, auf die Nachrichten zuzugreifen. Wir tun
          dies ausschließlich in folgenden Fällen: Bei begründetem Verdacht auf
          Verstöße gegen unsere Nutzungsbedingungen (z.B. Betrug, Spam,
          missbräuchliche Inhalte) – berechtigtes Interesse gemäß Art. 6 Abs. 1
          lit. f DSGVO oder zur Erfüllung gesetzlicher Verpflichtungen gemäß
          Art. 6 Abs. 1 lit. c DSGVO. Nachrichten werden zur Vertragserfüllung
          (Art. 6 Abs. 1 lit. b DSGVO) für 30 Tage gespeichert und danach
          automatisch gelöscht. Zusätzlich wurden technische Maßnahmen wie
          Passwortschutz, E-Mail-Authentifizierung und Zugriffskontrollen
          umgesetzt, um deine Nachrichten vor unbefugtem Zugriff zu schützen.
        </li>
        <br />
        <li>
          Registrierte Nutzer können über ein Kontaktformular Meldungen an den
          Betreiber senden, z.B. bei technischen Problemen oder Verstößen gegen
          die Nutzungsbedingungen. Die Verarbeitung erfolgt auf Grundlage
          unseres berechtigten Interesses am sicheren Betrieb der Plattform
          (Art. 6 Abs. 1 lit. f DSGVO). Die Nachrichten werden verschlüsselt
          gespeichert und sind ausschließlich für berechtigte Mitarbeiter des
          Betreibers sowie den Verfasser einsehbar. Nach Bearbeitung, spätestens
          nach 30 Tagen, werden die Meldungen gelöscht.
        </li>
        <br />
        <li>
          Alternativ steht die E-Mail-Adresse kontakt@surfanzeigen.de zur
          Kontaktaufnahme bereit. Der E-Mail-Versand erfolgt über die STRATO AG,
          die Verarbeitung findet innerhalb der Europäischen Union statt. Die
          Verarbeitung erfolgt auf Grundlage unseres berechtigten Interesses an
          der Kommunikation mit Nutzern (Art. 6 Abs. 1 lit. f DSGVO).
          Nachrichten werden nach abschließender Bearbeitung, spätestens nach 30
          Tagen, gelöscht.
        </li>
        <br />
        <li>
          Technisch notwendige Tokens (z.B. für Authentifizierung oder Sessions)
          werden lokal in deinem Browser gespeichert und können nur von dieser
          Website verwendet werden. Die Sicherheit dieser Daten hängt vom
          jeweiligen Browser und Gerät ab, daher empfehlen wir, stets aktuelle
          Softwareversionen zu verwenden, um bekannte Sicherheitslücken zu
          vermeiden. Auch Einstellungen wie der Dark-/Light-Modus werden lokal
          im Browser gespeichert, aber nicht an den Server übermittelt. Du
          kannst diese Daten jederzeit über die Browser-Einstellungen löschen.
        </li>
      </ul>
      <br />
      <p>
        <strong>3. Wofür wir die Daten verwenden</strong>
      </p>
      <ul>
        <li>
          Zur Bereitstellung und Verbesserung der Plattformfunktionen, z.B. für
          Nutzerkonten, Anzeigen und Profile. (Art. 6 Abs. 1 lit. b DSGVO –
          Vertragserfüllung).
        </li>
        <br />
        <li>
          Zur Kommunikation zwischen Käufern und Verkäufern über angebotene
          Produkte, z.B. zur Preisverhandlung, Terminabsprache oder Klärung von
          Produktdetails (Art. 6 Abs. 1 lit. b DSGVO – Vertragserfüllung).
        </li>
        <br />
        <li>
          Zur Sicherung der Plattform gegen Missbrauch, Betrug oder Spam (Art. 6
          Abs. 1 lit. f DSGVO). Unser berechtigtes Interesse besteht darin, eine
          funktionsfähige und sichere Plattform zu betreiben. Diese Maßnahmen
          sind erforderlich, da ohne sie der Plattformbetrieb durch Bots, Spam
          oder Betrug beeinträchtigt würde. Die Nutzer haben ihrerseits ein
          gleichgerichtetes Interesse an einer sicheren Plattform ohne
          Missbrauch, weshalb das Betreiberinteresse die schutzwürdigen
          Interessen der Betroffenen nicht überwiegt, sondern mit ihnen
          übereinstimmt. Konkret umfasst dies z.B. die Überprüfung von Inhalten
          bei begründetem Verdacht auf Verstöße.
        </li>
        <br />
        <li>
          Zur Erfüllung gesetzlicher Pflichten, soweit diese im Einzelfall
          anfallen, z.B. bei behördlichen Auskunftsersuchen oder gesetzlichen
          Aufbewahrungspflichten (Art. 6 Abs. 1 lit. c DSGVO).
        </li>
      </ul>
      <br />
      <p>
        <strong>4. Cookies &amp; ähnliche Technologien</strong>
      </p>
      <ul>
        <li>
          Wir setzen keine Werbe‑ oder Tracking‑Cookies ein. Es werden keine
          Daten an Dritte weitergegeben, um Nutzerprofile oder Werbung zu
          erstellen.
        </li>
        <br />
        <li>
          Authentifizierungs- und Session-Tokens werden verwendet, um Login,
          Datenzugriffe und Sicherheit zu gewährleisten (Art. 6 Abs. 1 lit. b
          DSGVO – Vertragserfüllung). Diese Tokens sind technisch einzigartig
          und enthalten ausschließlich notwendige Informationen zur
          Authentifizierung und Umsetzung der Plattformfunktionen. Auf Basis
          dieser Tokens wird gespeichert, wann der Nutzer zuletzt aktiv war, um
          inaktive Konten nach 1 Jahr automatisch zu löschen, Zugriffskontrollen
          zu verwalten und Besucher von Nutzern zu unterscheiden.
        </li>
        <br />
        <li>
          Einstellungen wie Dark-/Light-Modus oder andere persönliche
          Anzeigepräferenzen werden lokal im Browser gespeichert. Diese Daten
          werden nicht an den Server übertragen.
        </li>
        <br />
        <li>
          Du kannst Cookies und lokale Daten jederzeit über die Einstellungen
          deines Browsers löschen oder blockieren.
        </li>
        <br />
        <li>
          Authentifizierungsdaten werden nur zusammen mit Anfragen an den Server
          gesendet, die diese aus Sicherheitsgründen benötigen, z.B. zur
          Sicherstellung der Authentizität und Betrugsprävention. Diese
          Unterscheidung minimiert die Menge der übertragenen personenbezogenen
          Daten gemäß dem Grundsatz der Datensparsamkeit (Art. 5 Abs. 1 lit. c
          DSGVO).
        </li>
        <br />
        <li>
          Technisch notwendige Tokens und lokale Daten werden ausschließlich zur
          Bereitstellung und Verbesserung der Plattformfunktionen genutzt und
          nicht für andere Zwecke verarbeitet.
        </li>
      </ul>
      <br />

      <p>
        <strong>5. Speicherdauer</strong>
      </p>
      <ul>
        <li>Konten und deren Daten werden nach 1 Jahr Inaktivität gelöscht.</li>
        <br />
        <li>
          Anzeigen werden 180 Tage nach letzter Änderung oder bei Kontolöschung
          gelöscht.
        </li>
        <br />
        <li>
          Nachrichten werden 30 Tage nach Versenden bzw. Kontodeaktivierung
          gelöscht.
        </li>
        <br />
        <li>
          Bilder werden in Verbindung mit deren Nutzung gespeichert - wenn die
          Anzeige oder das Profil gelöscht wird, werden auch die zugehörigen
          Bilder gelöscht.
        </li>
        <br />
        <li>
          Meldungen bezüglich Problemen auf der Webseite werden nach der
          Bearbeitung gelöscht. Die Bearbeitung erfolgt bei normaler Auslastung
          innerhalb von einem Monat.
        </li>
        <br />
        <li>
          Daten, die wir zur Betrugsprävention oder wegen gesetzlicher Pflichten
          aufbewahren müssen, werden gesperrt und dann gelöscht oder
          anonymisiert, wenn die Aufbewahrungsfrist abläuft.
        </li>
      </ul>
      <br />
      <p>
        <strong>6. Deine Rechte</strong> Du hast das Recht auf:
      </p>
      <ul>
        <li>Auskunft über deine personenbezogenen Daten</li>
        <br />
        <li>Berichtigung falscher Daten</li>
        <br />
        <li>Löschung („Recht auf Vergessenwerden“)</li>
        <br />
        <li>Einschränkung der Verarbeitung</li>
        <br />
        <li>
          Datenübertragbarkeit (Art. 20 DSGVO) Soweit die Verarbeitung auf einer
          Einwilligung oder einem Vertrag beruht und automatisiert erfolgt,
          kannst du deine Daten in einem strukturierten, gängigen Format
          erhalten.
        </li>
        <br />
        <li>
          Widerspruch gegen die Verarbeitung (Art. 21 DSGVO) Du hast das Recht,
          der Verarbeitung deiner personenbezogenen Daten zu widersprechen,
          soweit diese auf berechtigtem Interesse (Art. 6 Abs. 1 lit. f DSGVO)
          beruht.
        </li>
        <br />
        <li>
          Widerruf erteilter Einwilligungen Du kannst eine erteilte Einwilligung
          jederzeit mit Wirkung für die Zukunft widerrufen, z.B. per E-Mail an
          kontakt@surfanzeigen.de. Der Widerruf berührt nicht die Rechtmäßigkeit
          der auf Grundlage der Einwilligung bis zum Widerruf erfolgten
          Verarbeitung.
        </li>
        <br />
        <li>
          Beschwerderecht bei der zuständigen Datenschutzaufsichtsbehörde (Art.
          77 DSGVO)
          <br />
          <p>
            Du kannst auch eine Beschwerde bei der zuständigen
            Datenschutzaufsichtsbehörde einreichen: Unabhängiges Landeszentrum
            für Datenschutz Schleswig-Holstein, Holstenstraße 98, 24103 Kiel
          </p>
        </li>
      </ul>
      <br />
      <p>
        Wenn du eines dieser Rechte ausüben willst, schreib uns bitte per
        E-Mail:
      </p>
      <a href="mailto:kontakt@surfanzeigen.de" className="link">
        Mail an kontakt@surfanzeigen.de senden
      </a>
      <br />

      <p>
        Wir bearbeiten deine Anfrage unverzüglich, spätestens innerhalb eines
        Monats nach Eingang.
      </p>
      <br />
      <p>
        <strong>7. Hosting und E-Mail-Versand</strong>
      </p>
      <ul>
        <li>
          Die statischen Frontend-Dateien (HTML, CSS, JavaScript) werden über
          Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA
          bereitgestellt. Dabei können Daten wie IP-Adresse und technische
          Anfrageinformationen auf Servern außerhalb der EU, insbesondere in den
          USA, verarbeitet werden. Die USA bieten kein mit der EU vergleichbares
          Datenschutzniveau; US-Behörden können unter Umständen auf diese Daten
          zugreifen, ohne dass wirksame Rechtsmittel dagegen bestehen. Die
          Übermittlung erfolgt auf Grundlage von Standardvertragsklauseln gemäß
          Art. 46 Abs. 2 lit. c DSGVO. Weitere Informationen unter
          vercel.com/legal/privacy-policy. Alle personenbezogenen Daten deines
          Nutzerkontos (E-Mail-Adresse, Anzeigen, Nachrichten, Profildaten)
          werden ausschließlich auf Servern der Netcup GmbH innerhalb der
          Europäischen Union gespeichert und verarbeitet. Für den Versand von
          E-Mails (z.B. sicherheitsrelevante Hinweise) nutzen wir die STRATO AG,
          Pascalstraße 10, 10587 Berlin. Die Verarbeitung erfolgt innerhalb der
          Europäischen Union (Art. 6 Abs. 1 lit. b DSGVO).
        </li>
        <br />
        <li>
          Für den Versand von E-Mails (z.B. systemrelevante Hinweise) nutzen wir
          den E-Mail-Dienstleister STRATO AG, Pascalstraße 10, 10587 Berlin. Die
          Verarbeitung erfolgt innerhalb der Europäischen Union (Art. 6 Abs. 1
          lit. b DSGVO).
        </li>
      </ul>
      <br />
      <p>
        <strong>8. Datensicherheit</strong> Wir nutzen technische Maßnahmen wie
        HTTPS-Verschlüsselung, Firewalls, sichere Token-Verwaltung und
        Datenbankverschlüsselung sowie organisatorische Maßnahmen bei der
        Speicherung sensibler Daten, um deine Daten bestmöglich zu schützen
        (Art. 32 DSGVO).
      </p>
      <br />
      <p>
        <strong>9. Änderungen dieser Datenschutzerklärung</strong> Wir können
        diese Datenschutzerklärung anpassen, z.B. wenn sich Funktionen oder
        rechtliche Anforderungen ändern. Die jeweils aktuelle Version wird auf
        unserer Website veröffentlicht. Bei wesentlichen Änderungen werden
        registrierte Nutzer per E-Mail informiert.
      </p>
      <br />
      <p>
        <strong>10. Besondere Hinweise</strong>
      </p>
      <ul>
        <li>
          Öffentlich sichtbare Inhalte: Anzeigen, Nutzername, Profilbild – diese
          sind für alle Plattformbesucher sichtbar. Bitte lade keine Bilder
          hoch, auf denen Personen erkennbar sind, ohne deren Einwilligung.
        </li>
        <br />
        <li>
          Falls du Daten von anderen Personen teilst (z.B. Namen, Kontakte),
          stelle bitte sicher, dass du deren Einwilligung hast.
        </li>
        <br />
        <li>
          Wir prüfen Nachrichten nur im Falle von Verstößen (z.B. Spam,
          Missbrauch), um die Sicherheit auf der Plattform zu gewährleisten.
        </li>
        <br />
        <li>
          Die Nutzung unserer Plattform setzt ein Mindestalter von 18 Jahren
          voraus. Diese Entscheidung treffen wir zum Schutz Minderjähriger, da
          Kleinanzeigenplattformen typischerweise Transaktionen zwischen
          Erwachsenen vermitteln. Personen unter 18 Jahren dürfen unsere
          Plattform nicht nutzen und kein Konto anlegen. Sollten wir
          feststellen, dass eine Person unter 18 Jahren ein Konto angelegt hat,
          werden wir dieses Konto und alle zugehörigen Daten unverzüglich
          löschen. Wir erheben wissentlich keine personenbezogenen Daten von
          Personen unter 18 Jahren. Falls du als Erziehungsberechtigter Kenntnis
          davon hast, dass ein Kind unter 18 Jahren ein Konto bei uns angelegt
          hat, bitten wir dich, uns unter kontakt@surfanzeigen.de zu
          kontaktieren.
        </li>
      </ul>
      <br />
    </article>
  );
};
export default DataProtection;
